import sortBy from 'lodash/sortBy.js'
import ShipperOptions from '@ordoro/shipper-options'

const SHIPPER_OPTIONS_ENTRIES = Object.entries(ShipperOptions)

export const SHIPPER_NAMES = SHIPPER_OPTIONS_ENTRIES.reduce(
  (prev, [shipperType, shipperOption]) => {
    prev[shipperType] = shipperOption.display_name

    return prev
  },
  [],
)

export const AMAZON_SFP = 'amazon'
export const AMAZON_SHIPPER = 'amazon_shipper'
export const AUSTRALIA_POST = 'australia_post'
export const CANADA_POST = 'canada_post'
export const DHL = 'dhl'
export const DHL_ECOMMERCE = 'dhl_ecommerce'
export const ENDICIA = 'endicia'
export const FEDEX = 'fedex'
export const FEDEX_360 = 'fedex_360'
export const NEWGISTICS = 'newgistics'
export const PITNEY = 'pitney'
export const PITNEY_CBDS = 'pitney_cbds'
export const PITNEY_MERCHANT = 'pitney_merchant'
export const PITNEY_PRESORT = 'pitney_presort'
export const SENDLE = 'sendle'
export const SHIPPO = 'shippo'
export const UPS = 'ups'
export const USPS_SHIP = 'usps_ship'

export const USPS_SHIPPERS = [
  ENDICIA,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  USPS_SHIP,
]

export const MULTI_CARRIER_SHIPPER = SHIPPER_OPTIONS_ENTRIES.filter(
  ([, {carrier}]) => carrier === 'multiple',
).map(([shipperType]) => shipperType)

export const SHIPPER_VENDORS = [
  AMAZON_SFP,
  AMAZON_SHIPPER,
  AUSTRALIA_POST,
  CANADA_POST,
  PITNEY_CBDS,
  DHL,
  DHL_ECOMMERCE,
  ENDICIA,
  FEDEX,
  FEDEX_360,
  NEWGISTICS,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  SENDLE,
  SHIPPO,
  UPS,
  USPS_SHIP,
]

export const ORDORO_SHIPPERS = [
  FEDEX_360,
  NEWGISTICS,
  PITNEY, // use_pitney
  PITNEY_CBDS,
  PITNEY_MERCHANT, // pitney_merchant
  PITNEY_PRESORT,
  SENDLE,
  // UPS, // DAP Only
  USPS_SHIP,
]

export const BYOA_SHIPPERS = [
  AMAZON_SHIPPER,
  AUSTRALIA_POST,
  FEDEX,
  // UPS, // Non-DAP Only
  CANADA_POST,
  DHL,
  DHL_ECOMMERCE,
]

export const MANUAL_TRACKING_SHIPPER_NAMES = sortBy(
  SHIPPER_OPTIONS_ENTRIES.filter(
    ([, {tracking_numbers}]) => tracking_numbers,
  ).map(([shipperType, shipperOption]) => ({
    value: shipperType,
    display: shipperOption.display_name,
  })),
  'display',
)

export function mapShipperToTrackingCarrier(shipperName) {
  if (!shipperName) {
    return null
  }

  shipperName = shipperName.toLowerCase()

  let shipperOption = SHIPPER_OPTIONS_ENTRIES.find(
    ([shipperType]) => shipperName === shipperType,
  )

  if (!shipperOption) {
    shipperOption = SHIPPER_OPTIONS_ENTRIES.find(
      ([, {display_name}]) => shipperName === display_name.toLowerCase(),
    )
  }

  if (!shipperOption) {
    shipperOption = SHIPPER_OPTIONS_ENTRIES.find(
      ([, {carrier}]) => shipperName === carrier,
    )
  }

  return shipperOption?.[1]?.carrier || 'other'
}

export const SHIPPERS_WITH_POSTAGE_BALANCES = [ENDICIA, PITNEY, PITNEY_MERCHANT]

export const SHIPPER_OPTIONS = [
  {value: AMAZON_SHIPPER, display: 'Amazon Shipping'},
  {value: AUSTRALIA_POST, display: 'Australia Post'},
  {value: CANADA_POST, display: 'Canada Post'},
  {value: DHL, display: 'DHL'},
  {value: DHL_ECOMMERCE, display: 'DHL eCommerce'},
  {value: FEDEX, display: 'FedEx'},
  {value: FEDEX_360, display: 'FedEx Discounted Rates'},
  {value: NEWGISTICS, display: 'PB Standard'},
  {value: PITNEY, display: 'USPS'},
  {value: PITNEY_CBDS, display: 'CBDS via Pitney'},
  {value: PITNEY_MERCHANT, display: 'USPS'},
  {value: PITNEY_PRESORT, display: 'USPS Presort'},
  {value: SENDLE, display: 'Sendle'},
  {value: SHIPPO, display: 'Shippo'},
  {value: UPS, display: 'UPS'},
  {value: USPS_SHIP, display: 'USPS Ship'},
]

export const HAS_CARRIER_LOGO = [
  'fedex',
  'fedex_360',
  'amazon',
  'amazon_shipper',
  'ups',
  'usps',
  'endicia',
  'pitney',
  'pitney_merchant',
  'pitney_presort',
  'usps_ship',
  'visible_usps',
  'canada_post',
  'australia_post',
  'dhl',
  'dhl_ecommerce',
  'dhl_express',
  'pitney_cbds',
  'newgistics',
  'sendle',
  'shippo',
]
